import styled from 'styled-components';

export const Container = styled.div`
  margin: 30px auto;
  max-width: 50vw;
  width: 80%;
  font-family: system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;

@media only screen and (max-width: 600px) {
    max-width: 100vw;
    width: 90%;
}

h2.rsc-header-title {
    color: #fff;
    font-weight: lighter;
}

button.rsc-os-option-element {
    background-color: #61045F;
}

`;

export const Title = styled.h1`
    color: white;
    font-weight: bold;
    text-align: center;
`;

export const Description = styled.p`
    color: white;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0.1em;
`;

export const Content = styled.p`
    color: white;
    font-weight: lighter;
    text-align: center;
    letter-spacing: 0.1em;
    line-spacing: 1px;
`;

export const NewLine = styled.br``;

export const BotTheme = {
    background: '#f5f8fb',
    fontFamily: 'system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
    headerBgColor: '#61045F',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#AA076B',
    botFontColor: '#fff',
    userBubbleColor: 'rgba(171, 7, 108, 0.28)',
    userFontColor: '#61045F',
};

export const Point = styled.b`
    font-weight: bold;
`;